import React, { Component } from 'react';
import * as Common from './../helpers/Common';
import {getFormValues} from './../helpers/Fields';
import * as Config from '../config/Config';
import * as User from '../helpers/User';
import Inputgenerator from '../components/Inputgenerator';
import {
    runValidation
} from '../helpers/Validation';

const $= window.$;

class Myquiz extends Component {
	constructor(props) {
		super(props);
        this.state={

        	chaptersub : '',
        	top : '',
        	ques_ans : [],
        	ques : [],
        	percentage:'',
        };




	}

	componentWillReceiveProps(nextProps) {
		//alert(nextProps.chaptersub);
		//alert('im here first');
		 // setTimeout(()=>{
			let chaptersub = nextProps.chaptersub;
			if(chaptersub != '__'){
				//this.getquiz(chaptersub);
				this.reset(chaptersub);
			}


		 // },1600);


	}
	reset(chaptersub){
		$('form#test_form')[0].reset();
		this.setState({
			percentage : '',
		})
		this.getquiz(chaptersub);
	}
	getquiz(chaptersub){
			//alert(chaptersub);
			$(".error").remove();

			let chaptesub = chaptersub;
			let learnerID = Common.getUserData("id", true);
			let productID = Common.getUserData("productID", true);

	    	fetch(Config.domainUrl+'resources/get-quiz', {
	                method: 'POST',
	                headers: {
	                  'Accept': 'application/json',
	                  'Content-Type': 'application/json',
					  'Authorization':'Bearer ' +Common.getTokenData()
	                },

	                  body: JSON.stringify({
	                    learnerID:learnerID,product:productID,chapsub:chaptesub
	                  })
	                }).then((response) => response.json())
	               .then((responseJson) => {
	               	//alert(JSON.stringify(responseJson)) ;

	               	if(responseJson.status != 0){

		                this.setState({
		                	ques : responseJson.ques_ans,
		                    ques_ans : responseJson.ques_ans.questions,
		                    top : responseJson.top,
		                    chaptersub : chaptersub,
		                });

		       //          if($('#chapter_menu').css('display') == 'none'){
				    	// 	$("#chapter_menu").css('display','block');
				    	// }
				    	// else{
				    		$("#chapter_menu").css('display','none');
				    	// }
	               	}


	   		 });

	}
	componentDidMount() {
		//alert('im in first');
		const {chaptersub} = this.props;
		//alert(chaptersub);
		if(chaptersub != '__'){
			this.getquiz(chaptersub);
	   	}


	}

	submitFeedback() {
		if (runValidation()) {
			let jsonFormData = getFormValues(this.state.ques);
			let learnerID = Common.getUserData("id", true);
			let productID = Common.getUserData("productID", true);
			Common.reactLoader("show", "Please wait...");
			fetch(Config.domainUrl+'resources/ans-quiz', {
	            method: 'POST',
	            headers: {
	              'Accept': 'application/json',
	              'Content-Type': 'application/json',
				  'Authorization':'Bearer ' +Common.getTokenData()
	            },

	              body: JSON.stringify({
	                learnerID:learnerID,product:productID,json_form_data: jsonFormData
	              })
	            }).then((response) => response.json())
	           .then((responseJson) => {
	           	Common.reactLoader("hide");
	            //alert(JSON.stringify(responseJson)) ;
	           	if (responseJson.status == 0) {
			       Common.message(responseJson.message,responseJson.errors,'error');
			    }
			    else{
			    	this.setState({
			    		ques : responseJson.ques_ans,
			    		ques_ans:responseJson.ques_ans.questions,
			    		percentage :responseJson.total,
			    	})
			    }



		   	});
			//alert(JSON.stringify(jsonFormData));
		}
	}

		render() {

			//alert(this.state.top);
			let ques_ans = "";
			let button = "";
			if(this.state.ques_ans!=undefined){
				 ques_ans = this.state.ques_ans.map((val, key)=>{
					let value = key+1;

					//alert(val.questionAnswerscore);

					return  (
							<div key={`ques_div_${key}`} className="lr-gray-box test">
								<div >
									<div className="margbtm para">
										<span className="bluetxt" >{'Q'+value}.</span>
										<span className="quetn" dangerouslySetInnerHTML={{__html:val.questionLabel}}/>
										<div className="clear"></div>
										<div className="test-ques">
											<a name={`bookmark${value}`}></a>
											<Inputgenerator key={`ques_inputgenerator_${key}`} qDetails={val} />
										</div>
										{(val.questionAnswerscore != null || val.questionAnswerscore == 0 )? <span><div className="dottedline"></div><span className="bluetxt score">{'Your Score -' + val.questionAnswerscore}</span></span> :  ""}
									</div>
								</div>
							</div>
						)
				})
			}
			(this.state.percentage)?button = <div className="slash_txt" > <div className="button" id="Active"><input type="button" name="btnsubmit" value="Re-do Assessment" onClick={()=>this.reset(this.state.chaptersub)}/></div></div>:button = <div className="slash_txt" > <div className="button" id="Active"><input type="button" name="btnsubmit" value="Submit" onClick={()=>this.submitFeedback()}/></div></div>;
			(this.state.ques_ans)? ques_ans = ques_ans : ques_ans = 'The chapter has no Assessment.';
			return (
				<div >
					<form name="test_form" id="test_form" method="post" action="#">
						<span dangerouslySetInnerHTML={{__html: this.state.top}}/>
						<div className="clear"></div>
						<span dangerouslySetInnerHTML={{__html:this.state.percentage}}/>
						<div className="clear"></div>
						{ques_ans}
						{button}
					</form>
				</div>
			);
		}
}

export default Myquiz;



// WEBPACK FOOTER //
// ./src/learning_resources/Myquiz.js